import styled from 'styled-components'

export const Container = styled.section`
    float: left;
    width: 100%;
    position: relative;
    background-color: #1A1B59;
    padding: 70px 60px;
    display: flex;
    justify-content: center;

    @media (max-width: 1000px) {
        padding: 50px 20px 50px 20px;
    }
`

export const ContainerInterno = styled.div`
    display: inline-block;
    width: 100%;
    max-width: 1436px;
    display: flex;
    align-items: center;

    @media (max-width: 1000px) {
        flex-direction: column;
    }
`

export const ColSm6 = styled.div`
    float: left;
    width: 50%;
    padding: 0 15px;

    @media (max-width: 1000px) {
        width: 100%;
        padding: 0;
    }
`

export const TagBonus = styled.span`
    background-color: rgb(239, 189, 94, 0.1);
    border: solid 1px #EFBD5E;
    border-radius: 100px;
    color: #EFBD5E;
    font-size: 14px;
    line-height: 14px;
    padding: 10px 15px;
    display: inline-block;
    font-weight: 700;
`

export const TituloPrincipal = styled.span`
    float: left;
    width: 100%;
    color: #FFFFFF;
    font-size: 30px;
    line-height: 40px;
    font-weight: 900;
    margin: 20px 0 20px 0;

    strong {
        color: #EFBD5E;
    }

    @media (max-width: 1300px) {
        br {
            display: none;
        }
    }

    @media (max-width: 768px) {
        font-size: 22px;
        line-height: 32px;
    }
`

export const TextoPrincipal = styled.span`
    float: left;
    width: 100%;
    color: #C3C9E6;
    font-size: 15px;
    line-height: 25px;

    strong {
        color: #EFBD5E;
    }

    @media (max-width: 1300px) {

        margin-bottom: 40px;

        br {
            display: none;
        }
    }

`

export const ListaConteudos = styled.ul`
    float: left;
    width: 100%;
    padding: 0;
    margin: 0;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 20px;
`

export const ListaConteudosItem = styled.li`
    float: left;
    width: 100%;
    list-style: none;
    background: rgb(255, 255, 255, 0.05);
    border: solid 1px #575757;
    border-radius: 14px;
    padding: 20px;
    display: flex;
    align-items: flex-start;

    @media (max-width: 768px) {
        padding: 15px;
    }
`

export const ListaConteudosItemIndex = styled.span`
    width: 35px;
    height: 35px;
    background: linear-gradient(90deg,rgba(189, 137, 59, 1) 0%, rgba(239, 189, 94, 1) 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100px;
    font-weight: 900;
    font-size: 16px;
    line-height: 16px;

    @media (max-width: 768px) {
        width: 30px;
        height: 30px;
    }
`

export const ListaConteudosItemTextos = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    padding-left: 15px;

    @media (max-width: 768px) {
        padding-left: 10px;
    }
`

export const ListaConteudosItemTextosTitulo = styled.span`
    color: #fff;
    font-weight: 600;
    margin-bottom: 7px;
`

export const ListaConteudosItemTextosTexto = styled.span`
    color: #C3C9E6;
    font-size: 14px;
    line-height: 20px;
`